import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { JWT_OPTIONS, JwtModule } from '@auth0/angular-jwt';
import { HttpInterceptorService } from './interceptors/http-interceptor.service';
import { AppConfig } from '../app-config.loader';
import { HasClaimDirective } from './directives/has-claim.directive';
import { IfLoggedDirective } from './directives/if-logged.directive';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './login/logout.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

function jwtOptionsFactory(appconfig: AppConfig) {
  return {
    tokenGetter: () => localStorage.getItem(appconfig.settings.jwt.tokenName),
    allowedDomains: appconfig.settings.jwt.whitelistedDomains,
    disallowedRoutes: [
      appconfig.settings.jwt.authenticationUrl,
      ...(appconfig.settings.jwt.blacklistedUrls ?? [])
    ]
  };
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild([
      { path: 'login', component: LoginComponent },
      { path: 'logout', component: LogoutComponent }
    ]),
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
        deps: [AppConfig]
      }
    })
  ],
  exports: [
    HasClaimDirective,
    IfLoggedDirective,
    LoginComponent,
    LogoutComponent
  ],
  declarations: [
    HasClaimDirective,
    IfLoggedDirective,
    LoginComponent,
    LogoutComponent
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass:HttpInterceptorService, multi: true}
  ],
})
export class AuthModule { }
